import { EmptyState, Icons } from "@jod/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useT } from "../features/i18n/index.ts";

export const Route = createFileRoute("/games")({
  component: GamesScreen,
});

/**
 * Games (FR-GAME-*) are not built yet — no `Game`/`GameRound` backend, no
 * venue-configurable enable/disable, no session wiring. The previous version
 * of this screen shipped a static, fully-fake activity list with a live
 * badge on two items that implied real, working functionality. That
 * was dishonest UI (see CLAUDE.md: never ship a feature that misrepresents
 * what actually works). Until FR-GAME-001+ is implemented, show a plain
 * "coming soon" state instead of fabricated content.
 */
function GamesScreen() {
  const t = useT();
  const navigate = useNavigate();

  return (
    <div className="mx-auto w-full max-w-md px-[18px] py-6">
      <button
        type="button"
        className="mb-4 flex items-center gap-1 text-cream-3 text-sm"
        onClick={() => navigate({ to: "/home" })}
      >
        <Icons.IconBack size={18} /> {t("common.back")}
      </button>

      <div className="jod-kicker">{t("games.kicker")}</div>
      <h1 className="h-display mt-1 text-[1.7rem]">{t("games.title")}</h1>

      <div className="mt-5">
        <EmptyState
          icon={<Icons.IconSparkle size={28} />}
          title={t("games.soon")}
          description={t("games.soonBody")}
        />
      </div>
    </div>
  );
}
